var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExternalLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern4)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern4",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_3179_9247",
    transform: "translate(-0.125 -0.125) scale(0.0125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_3179_9247",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAElUlEQVR4nO2dS4gdRRSGzxhfUUHcKPG98gkqzELwQevQ9f81c0dFtBeiiPhY6CYgIgbBcekLBQ2KgosgrnSRjWQRNboUFI24EhFFEjUEFY0vcGbkcHt0EO/tHp3uOvfW+aB2fadO9Tenqx/1EHEcx3Ecx3Ecx3Ecx+mNsiwvBPAwyedJvthXAfDQYDA4w1Wvg+QOAMskVxOVIyQH62PKlhjjQkIRfxUAP5LcJrlDck9qGeukPCC5A+AzQ0JekNwh+a4hITvFAjHGM2OMBcnrY4zVZhYA1y4uLp4wqm4AdzJ3IVVVbdG7CpKvkvymh8Z+D+D2EeHMkNyVrRAVAeCTBA1eCSFcNyauGwC8AmDvJpTvzAuZm5s7DcCbif8L3++6nQDuUfmmhYQQLiP5pYFLwh+zs7PHWJTRm5AQwuX1k2hSGRw2+BftMyzK6EWI3j0BOJhaBP8ur1mV0bmQoiiO1mu2AQmrdfl2YWHhHKsyOhcC4F4DElYBHNLbWgBnJZahx/2QREhRFCcB+LploAfqt62X6u9kQsAGZejxAPYlEULy/paBvjTuKXqaZMjwd8mEfNQi0GdkAsF/lJFMSFmWp7cI9EN9fSIZyUgmJMZ4Y1OweoxkJiOZEP1G3BDskaIojpfMZCQTQvLJhkr3ywQRY7xrA9/bV2KM9436W6kyZGdDpe9IZplhXcg+ySwz1nAhhmQoLsSQDMWFGJKhuBBDMhQXYkiG4kIMyVBciCEZigvp8aGvDSTfbqjnOcnxwRAJZCj1wMBxde2Q3IQgkYymN+E6RInk+ZKTECSUscaYYasPShdYFQIDMmpmdIB33cF/CuANnTTUUV02hcSe76ZMYU0Ih4Oolw1kRhosCamqaguAL7KVYU0IgAsMyJiJMR4nqbAkhOTFCe+mziX5Oslf9ZIJ4INx81OyEFJV1bENM7Q6kVGW5dn1ENZ/q2/UTK7pF6KQvHtEHMtdXabGPZHr7KqqqrZKrkLWSVmfKZ93efkgebjhMnmN5CxE0ZlTMcaL5ufnz+t61GRTvxVCuFlyF9InTUJ0unZvwbgQcSHW8AwxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhgsxhikhJJ9OvVRrSsqyPLnFN/X+xmcBeKQhoMNLS0tHyZQShkviNmXIVb0FBODWpoAAXCFTCoa79DSNltzW69ZBLYTslikkhHBii2VxD/QeGICvWqTtbTJlkHy5RXbs6j0wAE+0yJLfpkVKMVyj+NkWMrTdsfcAdbCxjvpuGeBu7VMmsaOvqmorgJsAfNyyrfuTtbNNlvzz7kuH7G/SdhF7uywk39ItNwD8vJE2JsmONQaDwSm6vPcGpUxz2SOpCSFcqX2FgZOxmrLotLoQwqliAZJ3pD4hTFt+ijFeIpaopyX/nmFmHNT9U8QiJK/OrE95T1f5Fsvo7gckH9WdbqY4Kw6R3K7PJjIp6F4eAB63sC8VN6es1JvXbNfXJzLJ6Ao4JG+p3xI/1efW2fx/5TFdMEZXitAd6FKfR8dxHMdxHMdxHMdxJCF/ArBGA51ESYhhAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternalLinkIcon);
export default __webpack_public_path__ + "static/media/ExternalLinkIcon.d54e14e1173e3e3af127f1abd2f292b2.svg";
export { ForwardRef as ReactComponent };